import { Lightning } from '@lightningjs/sdk';
import { t } from '../../i18n';
import { Button } from '../../tornado/button/button.component';
import { HEIGHT as BUTTON_HEIGHT } from '../../tornado/button/button.style';
import { getScreenSize } from '../../tornado/utils/sizes';
import { GAP, MIN_BUTTON_WIDTH } from './landingButtons.style';
import { buttons } from './customer/default/landingButtons.provider';
import { DIRECTION } from './landingButtons.constants';

export class LandingButtons extends Lightning.Component {
  static _template() {
    return {
      flex: {
        direction: DIRECTION,
      },
      ...buttons.reduce(
        (result, { id, label }) => ({
          ...result,
          [id]: {
            type: Button,
            label: t(label),
          },
        }),
        {},
      ),
    };
  }

  _construct() {
    this._index = 0;
  }

  _build() {
    const screenSize = getScreenSize();
    const isRow = DIRECTION === 'row';
    this.children.forEach(child => {
      child.flexItem = isRow ? { marginRight: GAP[screenSize] } : { marginBottom: GAP[screenSize] };
      if (!isRow) {
        child.minWidth = MIN_BUTTON_WIDTH[screenSize];
      }
    });

    this.h = this.children.length * (BUTTON_HEIGHT[screenSize] + GAP[screenSize]) - GAP[screenSize];
  }

  _getFocused() {
    return this.children[this._index];
  }

  _handleLeft() {
    if (DIRECTION === 'column') {
      return false;
    }

    if (this._index > 0) {
      this._index -= 1;

      return true;
    }

    return false;
  }

  _handleRight() {
    if (DIRECTION === 'column') {
      return false;
    }

    if (this._index < this.children.length - 1) {
      this._index = +1;

      return true;
    }

    return false;
  }

  _handleUp() {
    if (DIRECTION === 'row') {
      return false;
    }

    if (this._index > 0) {
      this._index -= 1;

      return true;
    }

    return false;
  }

  _handleDown() {
    if (DIRECTION === 'row') {
      return false;
    }

    if (this._index < this.children.length - 1) {
      this._index = +1;

      return true;
    }

    return false;
  }

  _handleEnter() {
    buttons[this._index].action();
    buttons[this._index].event();
  }
}
